export const isValidEmail = async (email) => {
  let validEmail = false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (emailRegex.test(email)) {
    validEmail = true;
  }
  return validEmail;
};
